import { render } from "./RechargePricesList.vue?vue&type=template&id=0f6743fe"
import script from "./RechargePricesList.vue?vue&type=script&lang=js"
export * from "./RechargePricesList.vue?vue&type=script&lang=js"

import "./RechargePricesList.vue?vue&type=style&index=0&id=0f6743fe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__